(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pick-quick-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.lcsSharedPickQuickReady) {
      if (typeof window.lcsInitSharedPickQuick === 'function') {
        window.lcsInitSharedPickQuick(document);
      }
      return;
    }

    window.lcsSharedPickQuickReady = true;

    class SharedPickQuick {
    constructor(root) {
      if (root.dataset.pickQuickReady === 'true' && root.__lcsSharedPickQuick) {
        return root.__lcsSharedPickQuick;
      }

      root.dataset.pickQuickReady = 'true';
      this.root = root;
      root.__lcsSharedPickQuick = this;
      this.productId = root.dataset.productId;
      this.productTitle = root.dataset.productTitle || '';
      this.panel = root.querySelector('[data-pick-quick-panel]');
      this.panelOriginalParent = this.panel ? this.panel.parentNode : null;
      this.panelOriginalNextSibling = this.panel ? this.panel.nextSibling : null;
      this.openButton = root.querySelector('[data-pick-quick-open]');
      this.closeButtons = root.querySelectorAll('[data-pick-quick-close]');
      this.form = root.querySelector('.pick-quick-form');
      this.variantsScript = root.querySelector('[data-pick-quick-variants]');
      this.variantInput = root.querySelector('[data-pick-quick-variant-id]');
      this.optionInputs = Array.from(root.querySelectorAll('.pick-quick-option input'));
      this.sideMediaList = root.querySelector('[data-pick-side-media-list]');
      this.sideMediaButtons = Array.from(root.querySelectorAll('[data-pick-side-media]'));
      this.imageStage = root.querySelector('[data-pick-image-stage]');
      this.touchStartY = null;
      this.quantityInput = root.querySelector('[data-pick-quick-quantity]');
      this.tierMessage = root.querySelector('[data-pick-tier-message]');
      this.minusButton = root.querySelector('[data-pick-quick-minus]');
      this.plusButton = root.querySelector('[data-pick-quick-plus]');
      this.priceEl = root.querySelector('[data-pick-quick-price]');
      this.compareEl = root.querySelector('[data-pick-quick-compare]');
      this.imageEl = root.querySelector('.pick-quick-panel__image');
      this.submitButton = root.querySelector('[data-pick-quick-submit]');
      this.buyNowButton = root.querySelector('[data-pick-quick-buy-now]');
      this.favoriteButton = root.querySelector('[data-pick-quick-favorite]');
      this.favoriteText = root.querySelector('[data-pick-favorite-text]');
      this.customerId = root.dataset.customerId || document.documentElement.dataset.customerId || 'guest';
      this.customerLoggedIn = root.dataset.customerLoggedIn === 'true' || document.documentElement.dataset.customerLoggedIn === 'true';
      this.favoritesKey = `lcs-favorites-${this.customerId || 'guest'}`;
      this.variants = [];
      this.currentVariant = null;
      this.selectedMediaButton = this.sideMediaButtons.find((button) => button.classList.contains('is-active')) || null;

      if (this.variantsScript) {
        try {
          this.variants = JSON.parse(this.variantsScript.textContent);
        } catch (error) {
          this.variants = [];
        }
      }

      this.bind();
      this.syncVariant();
      this.updateTierMessage();
      this.syncFavoriteState();
    }

    bind() {
      if (this.openButton) {
        this.openButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.open();
        });
      }

      this.closeButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        });
      });

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.commitOptionInput(input);
        });

        const visualPill = input.closest('.pick-quick-option__pill--visual');

        if (visualPill) {
          visualPill.addEventListener('mouseenter', () => this.previewOptionInput(input));
          visualPill.addEventListener('focusin', () => this.previewOptionInput(input));
          visualPill.addEventListener('mouseleave', () => this.clearOptionPreview());
          visualPill.addEventListener('focusout', () => this.clearOptionPreview());
          visualPill.addEventListener('touchstart', () => this.commitOptionInput(input), { passive: true });
        }
      });

      this.sideMediaButtons.forEach((button) => {
        button.addEventListener('click', () => this.showSideMedia(button, true));
        button.addEventListener('mouseenter', () => this.previewSideMedia(button));
        button.addEventListener('mouseleave', () => this.restoreSelectedMedia());
        button.addEventListener('focusin', () => this.previewSideMedia(button));
        button.addEventListener('focusout', () => this.restoreSelectedMedia());
      });

      this.bindMediaSwipe(this.imageStage);
      this.bindMediaSwipe(this.sideMediaList);

      if (this.minusButton) {
        this.minusButton.addEventListener('click', () => this.setQuantity(this.getQuantity() - 1));
      }

      if (this.plusButton) {
        this.plusButton.addEventListener('click', () => this.setQuantity(this.getQuantity() + 1));
      }

      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', () => this.setQuantity(this.getQuantity()));
      }

      if (this.favoriteButton) {
        this.favoriteButton.addEventListener('click', () => this.toggleFavorite());
      }

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart(false);
        });
      }

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', () => this.addToCart(true));
      }

      this.root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.panel && !this.panel.hidden) {
          this.close();
        }
      });
    }

    open() {
      if (!this.panel) {
        return;
      }

      if (this.panel.parentElement !== document.body) {
        document.body.appendChild(this.panel);
      }

      this.panel.hidden = false;
      document.documentElement.classList.add('pick-quick-modal-open');
      document.body.classList.add('pick-quick-modal-open');
      this.bindModalShield();

      if (this.openButton) {
        this.openButton.setAttribute('aria-expanded', 'true');
      }

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      const card = this.panel.querySelector('.pick-quick-panel__card');

      if (card) {
        card.scrollTop = 0;
      }

      const focusTarget = this.panel.querySelector('button, input, select');

      if (focusTarget) {
        focusTarget.focus();
      }
    }

    close() {
      if (!this.panel) {
        return;
      }

      this.panel.hidden = true;

      if (this.openButton) {
        this.openButton.setAttribute('aria-expanded', 'false');
        this.openButton.focus();
      }

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';

      if (!document.querySelector('.pick-quick-panel:not([hidden])')) {
        document.documentElement.classList.remove('pick-quick-modal-open');
        document.body.classList.remove('pick-quick-modal-open');
        this.unbindModalShield();
      }

      if (this.panelOriginalParent && this.panel.parentElement === document.body) {
        this.panelOriginalParent.insertBefore(this.panel, this.panelOriginalNextSibling);
      }
    }


    bindModalShield() {
      if (this.modalShieldReady) {
        return;
      }

      this.boundModalShield = (event) => {
        const openPanel = document.querySelector('.pick-quick-panel:not([hidden])');

        if (!openPanel) {
          return;
        }

        if (!openPanel.contains(event.target)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      };

      this.boundPanelStop = (event) => {
        event.stopPropagation();
      };

      ['click', 'pointerdown', 'pointerup', 'mousedown', 'mouseup', 'mouseover', 'mousemove', 'touchstart', 'touchend'].forEach((eventName) => {
        document.addEventListener(eventName, this.boundModalShield, true);
      });

      if (this.panel) {
        ['click', 'pointerdown', 'pointerup', 'mousedown', 'mouseup', 'mouseover', 'mousemove', 'touchstart', 'touchend'].forEach((eventName) => {
          this.panel.addEventListener(eventName, this.boundPanelStop, false);
        });
      }

      this.modalShieldReady = true;
    }

    unbindModalShield() {
      if (!this.modalShieldReady) {
        return;
      }

      ['click', 'pointerdown', 'pointerup', 'mousedown', 'mouseup', 'mouseover', 'mousemove', 'touchstart', 'touchend'].forEach((eventName) => {
        document.removeEventListener(eventName, this.boundModalShield, true);
      });

      if (this.panel) {
        ['click', 'pointerdown', 'pointerup', 'mousedown', 'mouseup', 'mouseover', 'mousemove', 'touchstart', 'touchend'].forEach((eventName) => {
          this.panel.removeEventListener(eventName, this.boundPanelStop, false);
        });
      }

      this.modalShieldReady = false;
    }

    getSelectedOptions() {
      const selected = {};

      this.optionInputs.forEach((input) => {
        if (input.checked) {
          selected[input.name] = input.value;
        }
      });

      return Object.values(selected);
    }

    syncVariant() {
      if (!this.variants.length) {
        return;
      }

      const selectedOptions = this.getSelectedOptions();
      const matchedVariant = this.variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]));
      this.currentVariant = matchedVariant || this.variants[0];

      if (this.variantInput && this.currentVariant) {
        this.variantInput.value = this.currentVariant.id;
      }

      const available = this.currentVariant && this.currentVariant.available;

      if (this.submitButton) {
        this.submitButton.disabled = !available;
      }

      if (this.buyNowButton) {
        this.buyNowButton.disabled = !available;
      }

      this.updatePrice();
      this.updateImageFromVariant();
      this.syncFavoriteState();

      const committedInput = this.optionInputs.find((input) => input.checked && input.closest('.pick-quick-option__pill--visual'));
      this.markCommittedPill(committedInput);
    }

    previewOptionInput(input) {
      if (!input) {
        return;
      }

      const pill = input.closest('.pick-quick-option__pill--visual');
      const values = pill ? pill.closest('.pick-quick-option__values') : null;

      if (values) {
        values.classList.add('is-previewing');
        values.querySelectorAll('.pick-quick-option__pill--visual.is-preview').forEach((item) => {
          item.classList.remove('is-preview');
        });
      }

      if (pill) {
        pill.classList.add('is-preview');
      }

      this.previewOptionImage(input);
    }

    clearOptionPreview() {
      (this.panel || this.root).querySelectorAll('.pick-quick-option__values.is-previewing').forEach((values) => {
        values.classList.remove('is-previewing');
      });

      (this.panel || this.root).querySelectorAll('.pick-quick-option__pill--visual.is-preview').forEach((pill) => {
        pill.classList.remove('is-preview');
      });

      this.restoreSelectedMedia();
    }

    commitOptionInput(input) {
      if (!input) {
        return;
      }

      const wasChecked = input.checked;

      if (!wasChecked) {
        input.checked = true;
      }

      this.clearOptionPreview();
      this.syncVariant();

      if (input.closest('.pick-quick-option__pill--visual')) {
        this.selectFirstMediaForOption(input);
      }
    }

    markCommittedPill(input) {
      (this.panel || this.root).querySelectorAll('.pick-quick-option__pill--visual.is-committed').forEach((pill) => {
        pill.classList.remove('is-committed');
      });

      if (!input) {
        return;
      }

      const pill = input.closest('.pick-quick-option__pill--visual');

      if (pill) {
        pill.classList.add('is-committed');
      }
    }

    previewSideMedia(button) {
      if (!button) {
        return;
      }

      this.showSideMedia(button, false);
    }

    previewOptionImage(input) {
      if (!input) {
        return;
      }

      const position = input.dataset.optionPosition;
      const value = input.value;
      const previewVariant = this.variants.find((variant) => {
        const optionValue = variant.options[Number(position) - 1];
        return optionValue === value && variant.featured_image;
      });

      if (previewVariant && previewVariant.featured_image && previewVariant.featured_image.src) {
        this.showImageSrc(previewVariant.featured_image.src, previewVariant.featured_image.id, true);
      }
    }

    selectFirstMediaForOption(input) {
      if (!input) {
        return;
      }

      const position = Number(input.dataset.optionPosition);
      const value = input.value;
      const label = (input.dataset.optionLabel || value || '').toLowerCase();
      const matchingVariant = this.variants.find((variant) => {
        const optionValue = variant.options[position - 1];
        return optionValue === value && variant.featured_image;
      });

      if (!matchingVariant || !matchingVariant.featured_image) {
        const mediaByAlt = this.sideMediaButtons.find((button) => {
          const alt = button.dataset.pickMediaAlt || '';
          return label && alt.includes(label);
        });

        if (mediaByAlt) {
          this.showSideMedia(mediaByAlt, true);
        }

        return;
      }

      const imageId = String(matchingVariant.featured_image.id || '');
      const matchingMediaButton = this.sideMediaButtons.find((button) => imageId && button.dataset.pickImageId === imageId);

      if (matchingMediaButton) {
        this.showSideMedia(matchingMediaButton, true);
        return;
      }

      if (matchingVariant.featured_image.src) {
        this.showImageSrc(matchingVariant.featured_image.src, matchingVariant.featured_image.id, false);
      }
    }

    showImageSrc(src, mediaId, temporary = false) {
      if (!src || !this.imageEl) {
        return;
      }

      this.imageEl.src = src;
      this.imageEl.removeAttribute('srcset');
      this.imageEl.removeAttribute('sizes');

      if (temporary) {
        this.sideMediaButtons.forEach((button) => button.classList.remove('is-active'));
        return;
      }

      this.sideMediaButtons.forEach((button) => {
        const isActiveByMedia = mediaId && button.dataset.mediaId === String(mediaId);
        const isActiveByImage = mediaId && button.dataset.pickImageId === String(mediaId);
        button.classList.toggle('is-active', Boolean(isActiveByMedia || isActiveByImage));
      });
    }

    showSideMedia(button, saveSelection = false) {
      if (!button || !this.imageEl) {
        return;
      }

      const src = button.dataset.pickMediaSrc;

      if (src) {
        this.imageEl.src = src;
        this.imageEl.removeAttribute('srcset');
        this.imageEl.removeAttribute('sizes');
      }

      this.sideMediaButtons.forEach((item) => item.classList.toggle('is-active', item === button));

      if (saveSelection) {
        this.selectedMediaButton = button;
      }

      if (typeof button.scrollIntoView === 'function') {
        button.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    restoreSelectedMedia() {
      if (this.selectedMediaButton) {
        this.showSideMedia(this.selectedMediaButton, false);
      }
    }

    updateImageFromVariant() {
      if (!this.currentVariant || !this.currentVariant.featured_image || !this.imageEl) {
        return;
      }

      if (this.currentVariant.featured_image.src) {
        this.showImageSrc(this.currentVariant.featured_image.src, this.currentVariant.featured_image.id, false);
      }
    }

    bindMediaSwipe(element) {
      if (!element) {
        return;
      }

      element.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaY) < 18) {
          return;
        }

        event.preventDefault();

        if (event.deltaY > 0) {
          this.showAdjacentSideMedia(1);
        } else {
          this.showAdjacentSideMedia(-1);
        }
      }, { passive: false });

      element.addEventListener('touchstart', (event) => {
        this.touchStartY = event.touches[0].clientY;
      }, { passive: true });

      element.addEventListener('touchend', (event) => {
        if (this.touchStartY === null) {
          return;
        }

        const endY = event.changedTouches[0].clientY;
        const delta = this.touchStartY - endY;

        if (Math.abs(delta) > 35) {
          if (delta > 0) {
            this.showAdjacentSideMedia(1);
          } else {
            this.showAdjacentSideMedia(-1);
          }
        }

        this.touchStartY = null;
      }, { passive: true });
    }

    getVisibleSideMediaButtons() {
      return this.sideMediaButtons.filter((button) => !button.hidden);
    }

    showAdjacentSideMedia(direction) {
      const visibleButtons = this.getVisibleSideMediaButtons();

      if (!visibleButtons.length) {
        return;
      }

      const activeIndex = visibleButtons.findIndex((button) => button.classList.contains('is-active'));
      const currentIndex = activeIndex >= 0 ? activeIndex : 0;
      const nextIndex = (currentIndex + direction + visibleButtons.length) % visibleButtons.length;
      this.showSideMedia(visibleButtons[nextIndex], true);
    }

    updatePrice() {
      if (!this.currentVariant || !this.priceEl) {
        return;
      }

      this.priceEl.textContent = this.formatMoney(this.currentVariant.price);

      if (this.compareEl) {
        if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
          this.compareEl.textContent = this.formatMoney(this.currentVariant.compare_at_price);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }
    }

    getQuantity() {
      if (!this.quantityInput) {
        return 1;
      }

      return Math.max(1, Number(this.quantityInput.value || 1));
    }

    setQuantity(quantity) {
      if (!this.quantityInput) {
        return;
      }

      this.quantityInput.value = Math.max(1, Number(quantity || 1));
      this.updateTierMessage();
    }

    getTierForQuantity(quantity) {
      if (quantity >= 5) {
        return { label: '5+ items', discount: '20%' };
      }

      if (quantity === 4) {
        return { label: '4 items', discount: '20%' };
      }

      if (quantity === 3) {
        return { label: '3 items', discount: '15%' };
      }

      if (quantity === 2) {
        return { label: '2 items', discount: '10%' };
      }

      return null;
    }

    updateTierMessage() {
      if (!this.tierMessage) {
        return;
      }

      const quantity = this.getQuantity();
      const tier = this.getTierForQuantity(quantity);

      if (!tier) {
        this.tierMessage.hidden = true;
        this.tierMessage.textContent = '';
        return;
      }

      this.tierMessage.hidden = false;
      this.tierMessage.innerHTML = `<strong>${tier.label}</strong> unlocked — enjoy <strong>${tier.discount} off</strong> this item`;
    }

    getFavoriteVariantId() {
      if (this.currentVariant && this.currentVariant.id) {
        return String(this.currentVariant.id);
      }

      if (this.variantInput && this.variantInput.value) {
        return String(this.variantInput.value);
      }

      return '';
    }

    getFavorites() {
      if (window.LCSFavorites && typeof window.LCSFavorites.read === 'function') {
        return window.LCSFavorites.read();
      }

      try {
        const saved = window.localStorage.getItem(this.favoritesKey);
        const parsed = saved ? JSON.parse(saved) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    saveFavorites(items) {
      if (window.LCSFavorites && typeof window.LCSFavorites.write === 'function') {
        window.LCSFavorites.write(items);
        return;
      }

      try {
        window.localStorage.setItem(this.favoritesKey, JSON.stringify(items));
        window.dispatchEvent(new CustomEvent('lcs:favorites:change', { detail: { items, count: items.length } }));
      } catch (error) {
        // localStorage can be unavailable in private browsing; fail softly.
      }
    }

    getFavoriteKey() {
      const variantId = this.getFavoriteVariantId();
      return `${this.productId || 'product'}:${variantId || 'variant'}`;
    }

    getFavoriteOptionDetails() {
      const details = [];

      this.optionInputs.forEach((input) => {
        if (!input.checked) return;
        const name = input.name.replace(/^options\[/, '').replace(/\]$/, '');
        details.push({ name, value: input.value });
      });

      return details;
    }

    buildFavoriteItem() {
      const variantId = this.getFavoriteVariantId();
      const quantity = this.getQuantity ? this.getQuantity() : 1;
      const image = this.imageEl ? this.imageEl.currentSrc || this.imageEl.src || '' : '';
      const options = this.getFavoriteOptionDetails();
      const colorOption = options.find((option) => /colou?r/i.test(option.name));
      const sizeOption = options.find((option) => /size/i.test(option.name));
      const price = this.currentVariant && typeof this.currentVariant.price === 'number' ? this.currentVariant.price : null;
      const available = this.currentVariant ? Boolean(this.currentVariant.available) : true;
      const handle = this.root.dataset.productHandle || '';
      const url = this.root.dataset.productUrl || (handle ? `/products/${handle}` : window.location.pathname);

      return {
        key: this.getFavoriteKey(),
        productId: String(this.productId || ''),
        variantId: String(variantId || ''),
        handle,
        title: this.productTitle || '',
        url,
        image,
        price,
        priceText: this.priceEl ? this.priceEl.textContent.trim() : '',
        options,
        optionSummary: options.map((option) => `${option.name}: ${option.value}`).join(' / '),
        color: colorOption ? colorOption.value : '',
        size: sizeOption ? sizeOption.value : '',
        quantity: Math.max(1, quantity),
        available,
        savedAt: new Date().toISOString()
      };
    }

    syncFavoriteState() {
      if (!this.favoriteButton) {
        return;
      }

      const key = this.getFavoriteKey();
      const isActive = window.LCSFavorites && typeof window.LCSFavorites.has === 'function'
        ? window.LCSFavorites.has(key)
        : this.getFavorites().some((item) => item && item.key === key);
      this.favoriteButton.classList.toggle('is-active', isActive);
      this.favoriteButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      if (this.favoriteText) {
        this.favoriteText.textContent = isActive ? 'Favorited' : 'Favorite';
      }
    }

    toggleFavorite() {
      if (!this.favoriteButton) {
        return;
      }

      const loggedIn = window.LCSFavorites && typeof window.LCSFavorites.isLoggedIn === 'function'
        ? window.LCSFavorites.isLoggedIn()
        : this.customerLoggedIn;

      if (!loggedIn) {
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/account/login?return_url=${returnUrl}`;
        return;
      }

      const item = this.buildFavoriteItem();
      const isActive = window.LCSFavorites && typeof window.LCSFavorites.has === 'function'
        ? window.LCSFavorites.has(item.key)
        : this.getFavorites().some((favorite) => favorite && favorite.key === item.key);

      if (window.LCSFavorites && typeof window.LCSFavorites.add === 'function') {
        if (isActive) {
          window.LCSFavorites.remove(item.key);
        } else {
          window.LCSFavorites.add(item);
        }
      } else {
        const favorites = this.getFavorites();
        const existingIndex = favorites.findIndex((favorite) => favorite && favorite.key === item.key);
        if (existingIndex >= 0) {
          favorites.splice(existingIndex, 1);
        } else {
          favorites.unshift(item);
        }
        this.saveFavorites(favorites);
      }

      this.syncFavoriteState();
    }

    async addToCart(goToCheckout) {
      if (!this.variantInput) {
        return;
      }

      const variantId = Number(this.variantInput.value);
      const quantity = this.getQuantity();

      if (!variantId) {
        return;
      }

      const clickedButton = goToCheckout ? this.buyNowButton : this.submitButton;
      const originalText = clickedButton ? clickedButton.textContent : '';

      if (clickedButton) {
        clickedButton.disabled = true;
        clickedButton.textContent = goToCheckout ? 'Opening checkout...' : 'Adding...';
      }

      try {
        const sectionIds = this.getCartSectionIds();
        const payload = {
          id: variantId,
          quantity: quantity,
          properties: {
            _tier_product_id: this.productId,
            _tier_product_title: this.productTitle
          }
        };

        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const addResponse = await response.json().catch(() => ({}));

        if (!response.ok || addResponse.status) {
          throw new Error(addResponse.message || 'Unable to add item');
        }

        const cart = await this.fetchCart();
        this.dispatchCartUpdate(cart, addResponse.sections, quantity, variantId);

        if (goToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        if (clickedButton) {
          clickedButton.textContent = 'Added';
        }

        this.close();

        window.setTimeout(() => {
          if (clickedButton) {
            clickedButton.disabled = false;
            clickedButton.textContent = originalText;
          }
        }, 1200);
      } catch (error) {
        if (clickedButton) {
          clickedButton.disabled = false;
          clickedButton.textContent = error && error.message ? error.message : originalText;

          window.setTimeout(() => {
            clickedButton.textContent = originalText;
          }, 2500);
        }
      }
    }

    getCartSectionIds() {
      const sectionIds = [];

      document.querySelectorAll('cart-items-component').forEach((component) => {
        if (component instanceof HTMLElement && component.dataset.sectionId) {
          sectionIds.push(component.dataset.sectionId);
        }
      });

      return [...new Set(sectionIds)];
    }

    async fetchCart() {
      try {
        const response = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          return null;
        }

        return await response.json();
      } catch (error) {
        return null;
      }
    }

    dispatchCartUpdate(cart, sections, quantity, variantId) {
      const itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : quantity;

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || { item_count: itemCount },
            sourceId: `pick-quick-${this.productId}`,
            data: {
              source: 'pick-quick-card',
              itemCount: itemCount,
              productId: this.productId,
              variantId: String(variantId),
              sections: sections || {}
            }
          }
        })
      );
    }

    formatMoney(cents) {
      const amount = Number(cents || 0) / 100;
      const currencyCode = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currencyCode
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    }
  }

  function initSharedPickQuick(context = document) {
    const scope = context && context.querySelectorAll ? context : document;

    scope.querySelectorAll('[data-pick-quick]').forEach((root) => {
      if (!root.__lcsSharedPickQuick) {
        if (root.dataset.pickQuickReady === 'true') {
          root.dataset.pickQuickReady = 'false';
        }

        root.__lcsSharedPickQuick = new SharedPickQuick(root);
      }
    });
  }

  function openPickQuickFromButton(openButton, event) {
    const root = openButton ? openButton.closest('[data-pick-quick]') : null;

    if (!root) {
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!root.__lcsSharedPickQuick) {
      if (root.dataset.pickQuickReady === 'true') {
        root.dataset.pickQuickReady = 'false';
      }

      root.__lcsSharedPickQuick = new SharedPickQuick(root);
    }

    if (root.__lcsSharedPickQuick && typeof root.__lcsSharedPickQuick.open === 'function') {
      root.__lcsSharedPickQuick.open();
    }
  }

  if (!window.lcsSharedPickQuickDelegatedOpenReady) {
    window.lcsSharedPickQuickDelegatedOpenReady = true;

    document.addEventListener(
      'click',
      (event) => {
        const openButton = event.target.closest('[data-pick-quick-open]');

        if (!openButton) {
          return;
        }

        openPickQuickFromButton(openButton, event);
      },
      true
    );
  }

  window.lcsInitSharedPickQuick = initSharedPickQuick;
  initSharedPickQuick();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSharedPickQuick(document));
  } else {
    initSharedPickQuick(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSharedPickQuick(event.target);
  });
  })();
  } catch(e) { console.error(e); }
})();

})();
